var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 74,
    viewBox: "0 0 60 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5810"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M59.1 19.2929L38.1 0.792857C37.5 0.264286 36.9 0 36 0H6C2.7 0 0 2.37857 0 5.28571V68.7143C0 71.6214 2.7 74 6 74H54C57.3 74 60 71.6214 60 68.7143V21.1429C60 20.35 59.7 19.8214 59.1 19.2929ZM36 6.34286L52.8 21.1429H36V6.34286ZM54 68.7143H6V5.28571H30V21.1429C30 24.05 32.7 26.4286 36 26.4286H54V68.7143Z",
    fill: "#018C0D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 52.8571H48V58.1429H12V52.8571ZM12 37H48V42.2857H12V37Z",
    fill: "#018C0D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrite);
export default __webpack_public_path__ + "static/media/write.cdf7b713118ddc3a4774a252202b775f.svg";
export { ForwardRef as ReactComponent };